import { Component, OnInit, Input } from '@angular/core';

import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';

import { ViewCodingChallengeModalComponent } from './library/view/view.component';

import { AuthService } from '../../../../../../providers/auth.service';
import { SharedHackService } from '../../../../shared/services/shared-hack.service';
import { ScreenTalentService } from '../../../screen-talent.service';

import { default as swal } from 'sweetalert2';


export class CodingComponent implements OnInit {

	 public challenges: any[];
	 public editable: boolean = false;
	 public library: boolean = false;
	 public hackId: string;
	 public test: any;
	 public visibility: string = 'public';

	public view: string = 'default';

	constructor(
		public modal: Modal,
		private authService: AuthService,
		private sharedHackService: SharedHackService,
		private screenTalentService: ScreenTalentService) { }

	// Lifecycle Events
	public ngOnInit(): void {
		if (this.library) {
			this.view = 'library';
		} else {
			this.view = 'default';
		}
	}

	// Events
	public onViewChallengeClick(challengeId: string): void {
		let data: any = { challengeId, editable: this.editable, hackChallengeId: challengeId };
		let modalSettings: any = {
			size: 'lg',
			initData: data
		};
		this.modal.open(ViewCodingChallengeModalComponent, overlayConfigFactory(modalSettings, BSModalContext))
			.then((result) => { result.result.then(
				() => {
					this.screenTalentService.emitEventAction({ component: 'summary', action: 'getHack', data: {} });
				},
				() => {
					this.screenTalentService.emitEventAction({ component: 'summary', action: 'getHack', data: {} });
				});
			});
	}

	public onDeleteChallengeClick(challengeId: string) {
		swal({
			title: 'Are you sure you want to remove this challenge from the test?',
			text: '',
			type: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#E06160',
			confirmButtonText: 'Yes',
			cancelButtonText: 'No',
			allowOutsideClick: false,
			allowEscapeKey: false,
			reverseButtons: true
		}).then(() => {
			this.sharedHackService.deleteCodingChallenge(String(this.authService.userId), challengeId).subscribe(
				(resp) => {
					this.screenTalentService.emitEventAction({ component: 'summary', action: 'getHack', data: {} });
				}
			);
		}, () => undefined);
	}

	// Helpers

static ctorParameters() { return [ { type: Modal }, { type: AuthService }, { type: SharedHackService }, { type: ScreenTalentService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/summary/coding/coding.component.ts